import { baseApi } from '@ibk/shared-config';
export const limitsApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getAccountLimits: builder.query({
            query: ({ transactionType, all = false }) => ({
                url: `/v1/accounts/limits/${transactionType.toLowerCase()}`,
                params: { all },
                forceSelectedAccountInfoAccountId: true,
            }),
            providesTags: ['Base'],
        }),
        getTransactionalSettings: builder.query({
            query: () => ({
                url: '/v1/accounts/transactional/settings',
                forceSelectedAccountInfoAccountId: true,
            }),
            providesTags: ['Base'],
        }),
        updateAccountLimits: builder.mutation({
            query: ({ transactionType, body }) => ({
                url: `/v1/accounts/limits/${transactionType.toLowerCase()}`,
                method: 'POST',
                body,
                forceSelectedAccountInfoAccountId: true,
            }),
            invalidatesTags: ['Base'],
        }),
    }),
});
export const { useLazyGetAccountLimitsQuery, useLazyGetTransactionalSettingsQuery, useUpdateAccountLimitsMutation } = limitsApi;
